import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import api from '../../../../../components/api';

function useRenderTableService(status: number | string, page: number) {
  const navigation = useNavigate();
  // Navigate to editServiceRequest
  const onNavigateToEditService = (id: number) => navigation(`/customer-support/service/add/${id}`);
  // Navigate to add Invoice by Ticket Id
  const onNavigateToAddInvoice = (id: number) => navigation(`/customer-support/add-invoice/${id}`);

  const { data: serviceRes, isLoading: serviceLoad } = useQuery(
    !status ? ['getAllServiceRequests', 'customerSupport', page - 1, 10]
      : ['getAllServiceRequestsByStatus', 'customerSupport', status ?? '', page - 1, 10],
    () => {
      if (!status) {
        return api.customerSupport.getAllServiceRequests(page - 1, 10);
      }
      return api.customerSupport.getAllServiceRequestsByStatus(status ?? '', page - 1, 10);
    },
  );

  const serviceData = React.useMemo(() => {
    const resData = serviceRes?.data;
    return {
      data: resData?.data,
      totalPages: resData?.totalPages ?? 1,
    };
  }, [serviceRes]);

  return {
    service: {
      data: serviceData.data,
      totalPages: serviceData.totalPages,
      load: serviceLoad,
    },
    navigate: {
      edit: onNavigateToEditService,
      invoice: onNavigateToAddInvoice,
    },
  };
}

export default useRenderTableService;
